import React from 'react';
import { getBankFromHrIban, isHrIbanValid } from './ibanUtils';
import { TextField } from '../TextField';
import { IbanTextFieldProps } from './types';




const IbanTextField: React.FC<IbanTextFieldProps> = ({
  value,
  onChange,
  error,
  showBankName = true,
  ...props
}) => {
  const iban = typeof value === 'string' ? value : '';

  const banka = React.useMemo(() => {
    return getBankFromHrIban(iban);
  }, [iban]);

  const isValid = React.useMemo(() => {
    if (!iban) return true;
    return isHrIbanValid(iban);
  }, [iban]);

  const validationError = !isValid ? 'Neispravan IBAN' : (!iban ? error : undefined);

  return (
    <div className="flex flex-col ">
      <TextField
        {...props}
        value={value}
        onChange={onChange}
        error={validationError}
        forceShowError={!!validationError}
        disableDebounce
      />

      {showBankName && banka && (
        <div className="text-sm text-slate-600 mt-1 pl-1">
         {banka.name}
        </div>
      )}
    </div>
  );
};

export default React.memo(IbanTextField);
